'use strict';

import { dgmmcResultsFinals } from '../archives/dgmmcfinals';
try {
   const resultsContainer = document.querySelector('.allresults');
   const searchForm = document.querySelector('.examresults__search');

   function getResultHtml(stdResult) {
      return `
       <div class="student-result student-result--${''}" data-fullname="${
         stdResult.name + ' ' + stdResult.surname
      }">
         <div class="student-result__section">
            <h4 class="student-result__title">NAME</h4>
            <span class="student-result__value">${titleCaseWord(
               stdResult.name
            )}</span>
         </div>
         <div class="student-result__section">
            <h4 class="student-result__title">SURNAME</h4>
            <span class="student-result__value">${titleCaseWord(
               stdResult.surname
            )}</span>
         </div>
         <div class="student-result__section">
            <h4 class="student-result__title">CLASS</h4>
            <span class="student-result__value">${stdResult.currentClass}</span>
         </div>
         <div class="student-result__section">
            <h4 class="student-result__title">SCORE (%)</h4>
            <span class="student-result__value">${
               stdResult.score || 'No score recorded'
            }</span>
         </div>
         <div class="student-result__section" id="school">
            <h4 class="student-result__title">SCHOOL</h4>
            <span class="student-result__value">
               ${stdResult.school}
            </span>
         </div>
      </div>
      `;
   }

   function titleCaseWord(str) {
      return str[0].toUpperCase() + str.slice(1).toLowerCase();
   }
   function init() {
      dgmmcResultsFinals.forEach((std) => {
         resultsContainer.insertAdjacentHTML('beforeend', getResultHtml(std));
      });
   }
   function getResultElementBySearchQuery(query) {
      return resultElems.find((elem) =>
         elem.dataset.fullname.toLowerCase().includes(query.toLowerCase())
      );
   }

   init();
   var resultElems = [...document.querySelectorAll('.student-result')];

   searchForm.addEventListener('submit', (ev) => {
      ev.preventDefault();
      const searchText = ev.currentTarget
         .querySelector('#examresults__search__input')
         .value.trim();
      if (!searchText) return;

      const foundElem = getResultElementBySearchQuery(searchText);
      console.log(foundElem);
      foundElem.scrollIntoView({ behavior: 'smooth' });

      setTimeout(() => {
         foundElem.style.backgroundColor = 'white';
         foundElem.style.color = 'rgb(119, 119, 119)';
      }, 1000);

      foundElem.style.backgroundColor = 'black';
      foundElem.style.color = 'white';
   });
} catch (err) {
   console.log('Handled: ', err);
}
